import React, {Component} from "react";
import {Image} from "react-bootstrap";
import {cities, fileTypes, provinces, usageTypes} from "../../../constants";
import Auction from "../../Auction";

export class Navigation extends Component {
    constructor(props) {
        super(props);

        this.state = {
            all_links: [],
            suggestions: [],
        };
    }

    collectLinks = () => {
        const all_links = Array.from(document.querySelectorAll("a"))
            .map(link => ({ title: link.textContent, url: link.href}));

        this.setState({ all_links });
    };

    handleSearch = (e) => {
        this.setState({ suggestions: [] });
        const value = e.target.value;
        if (value) {
            const suggestions = this.state.all_links.filter(link => link.title.toLowerCase().includes(value.toLowerCase()));
            this.setState({ suggestions });
        }
    };

    render() {
        return (
            <nav className="navbar navbar-expand-lg static main-bg">
                <div className="container">

                    <a className="logo icon-img-55 pt-1 pb-1" href={"/"}>
                        <Image src={process.env.REACT_APP_BASE_URL + "/images/logo/logo.png"} alt="logo"/>
                    </a>

                    <button className="navbar-toggler" type="button" data-toggle="collapse"
                            data-target="#navbarSupportedContent"
                            aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="icon-bar"><i className="fas fa-bars"> </i></span>
                    </button>

                    <div className="collapse navbar-collapse justify-content-center" id="navbarSupportedContent">
                        <ul className="navbar-nav">
                            {/*<li className="nav-item">
                                <span className="nav-link" href={"/"}>خانه</a>
                            </li>*/}
                            <li className="nav-item dropdown">
                                <span className="nav-link dropdown-toggle" data-toggle="dropdown" role="button"
                                   aria-haspopup="true" aria-expanded="false">معرفی شرکت</span>
                                <div className="dropdown-menu">
                                    <a className="dropdown-item" href={"/pages/about-us"}>درباره ما</a>
                                    <a className="dropdown-item" href={"/pages/pillars"}>ارکان جهت ساز</a>
                                    <a className="dropdown-item" href={"/pages/structure"}>ساختار سازمانی</a>
                                </div>
                            </li>
                            <li className="nav-item dropdown">
                                <span className="nav-link dropdown-toggle" data-toggle="dropdown" role="button"
                                   aria-haspopup="true" aria-expanded="false">مزایده‌ و فروش املاک</span>
                                <div className="dropdown-menu">
                                    <a className="dropdown-item" href={"/auctions/active"}>مزایده‌های جاری</a>
                                    <a className="dropdown-item" href={"/auctions/archive"}>مزایده‌های پیشین</a>
                                    <a className="dropdown-item" href={'/estates'} >معرفی کلیه املاک قابل فروش</a>
                                </div>
                            </li>
                            <li className="nav-item dropdown">
                                <span className="nav-link dropdown-toggle" data-toggle="dropdown" role="button"
                                   aria-haspopup="true" aria-expanded="false">پروژه‌های ساختمانی</span>
                                <div className="dropdown-menu">
                                    <a className="dropdown-item" href={'/projects/under-construction'}>پروژه‌های فعال</a>
                                    <a className="dropdown-item" href={'/projects/completed'}>پروژه‌های اتمام یافته</a>
                                </div>
                            </li>
                            <li className="nav-item dropdown">
                                <span className="nav-link dropdown-toggle" data-toggle="dropdown" role="button"
                                   aria-haspopup="true" aria-expanded="false">بازسازی و بهسازی</span>
                                <div className="dropdown-menu">
                                    <a className="dropdown-item" href={"/renovations/under-construction"}>پروژه‌های فعال</a>
                                    <a className="dropdown-item" href={"/renovations/completed"}>پروژه‌های اتمام یافته</a>
                                </div>
                            </li>
                            <li className="nav-item dropdown">
                                <span className="nav-link dropdown-toggle" data-toggle="dropdown" role="button"
                                   aria-haspopup="true" aria-expanded="false">سامانه‌های الکترونیکی</span>
                                <div className="dropdown-menu">
                                    <a className="dropdown-item" href="https://chargoon.paidariranian.ir/" target="_blank">سامانه اداری</a>
                                    <a className="dropdown-item" href={process.env.REACT_APP_API_URL + "/admin"} target="_blank">سامانه ما (مدیریت املاک)</a>
                                </div>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" href={"/pages/contact-us"}>تماس با ما</a>
                            </li>
                        </ul>
                    </div>

                    <div className="search-form">
                        <div className="form-group">
                            <input
                                type="text"
                                name="search"
                                placeholder="جستوجو"
                                onChange={this.handleSearch}
                            />
                            <button>
                                <span className="pe-7s-search"> </span>
                            </button>
                            {/* Suggestions section */}
                            {this.state.suggestions.length >= 1 && <div className="ml-auto">
                                <div className="search-suggestions">
                                    <ul className="select-options ml-15 mr-15">
                                        {Object.values(this.state.suggestions).map((value, key) => (
                                            <li key={key}>
                                                <a href={value.url} style={{display: 'list-item'}}>{value.title}</a>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>}{/* End of Suggestions section */}
                        </div>
                        <div className="search-icon" onClick={this.collectLinks}>
                            <span className="pe-7s-search open-search"> </span>
                            <span className="pe-7s-close close-search"> </span>
                        </div>
                    </div>

                    <div className="sign-in-form">
                        <div className="form-group">
                            <div className="ml-auto">
                                <div className="search-suggestions">
                                    <ul className="select-options ml-15 mr-15">
                                        <li><a href={process.env.REACT_APP_API_URL + "/login"} style={{display: 'list-item'}}>ورود</a></li>
                                        <li><a href={process.env.REACT_APP_API_URL + "/register"} style={{display: 'list-item'}}>ایجاد حساب</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="sign-in-icon">
                            <span className="pe-7s-user open-sign-in"> </span>
                            <span className="pe-7s-close close-sign-in"> </span>
                        </div>
                    </div>
                </div>
            </nav>
        );
    }
}
